var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _line, _line2, _line3, _line4, _path, _path2, _line5, _line6, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _line7, _line8, _rect7, _rect8, _rect9, _path11, _rect10, _rect11, _rect12, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1Frame16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 353,
    viewBox: "0 0 637 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.0001,
    height: 17.1439,
    transform: "matrix(0.999946 0.0078119 0.00170115 -0.999987 293.36 236.814)",
    fill: "url(#paint0_linear_424_3509)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00012,
    height: 35.3975,
    transform: "matrix(0.999937 0.00841963 -0.00157834 0.999987 293.32 264.421)",
    fill: "url(#paint1_linear_424_3509)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.0001,
    height: 30.0018,
    transform: "matrix(0.999946 0.0078119 0.00170115 -0.999987 317.36 237.001)",
    fill: "url(#paint2_linear_424_3509)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00012,
    height: 61.3556,
    transform: "matrix(0.999935 0.00860229 -0.00154483 0.999987 317.319 264.628)",
    fill: "url(#paint3_linear_424_3509)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.0001,
    height: 17.1439,
    transform: "matrix(0.999946 0.0078119 0.00170115 -0.999987 339.359 237.173)",
    fill: "url(#paint4_linear_424_3509)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.00012,
    height: 35.3975,
    transform: "matrix(0.999935 0.00860229 -0.00154483 0.999987 339.319 264.817)",
    fill: "url(#paint5_linear_424_3509)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.1414,
    y1: 222,
    x2: 21.1414,
    y2: 227,
    stroke: "#D9D9D9",
    strokeOpacity: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.999756,
    y1: 221.5,
    x2: 21.9998,
    y2: 221.5,
    stroke: "url(#paint6_linear_424_3509)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 5,
    y2: -0.5,
    transform: "matrix(5.85695e-10 1 1 0 615.306 222)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 21,
    y2: -0.5,
    transform: "matrix(-1 0 1.20033e-10 1 635 222)",
    stroke: "url(#paint7_linear_424_3509)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.632 18.4575C115.649 15.4136 115.695 7.34141 115.715 3.68577C115.801 2.79052 107.303 1.18014 104.997 1.18014L10.7805 1",
    stroke: "url(#paint8_linear_424_3509)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M530.741 18.4575C530.724 15.4136 530.678 7.34141 530.657 3.68577C530.572 2.79052 539.07 1.18014 541.375 1.18014L635.592 1",
    stroke: "url(#paint9_linear_424_3509)",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1.00024,
    y1: 270.5,
    x2: 26.0002,
    y2: 270.5,
    stroke: "url(#paint10_linear_424_3509)"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 25,
    y2: -0.5,
    transform: "matrix(-1 0 -1.20026e-10 1 635 271)",
    stroke: "url(#paint11_linear_424_3509)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M340.382 218.143L340.87 132.198C340.797 131.005 341.563 128.796 345.215 129.513L516.951 129.513C518.716 129.14 522.915 129.692 525.579 134.884L569.493 195.314C570.845 197.179 574.368 200.909 577.639 200.909L634.644 200.909",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M295.156 218.367L295.644 132.341C295.731 131.146 294.989 128.935 291.326 129.652L119.454 129.652C117.691 129.279 113.483 129.832 110.757 135.03L66.1217 195.531C64.747 197.398 61.1791 201.133 57.9053 201.133L0.855156 201.133",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M294.601 317.069L294.561 324.231C294.635 325.276 294.158 327.365 291.657 327.365L221.663 327.365C221.022 327.365 219.265 326.111 217.37 321.098C216.953 319.997 214.995 315.175 212.016 307.893M0.737283 221.948L20.8212 221.948M138.139 189.943L138.119 193.524L138.161 186.138M138.139 189.943L149.504 189.943M138.139 189.943L126.774 189.943M149.504 189.943L160.869 189.943C162.985 189.943 164.463 192.33 164.937 193.524C175.141 218.249 191.762 258.563 203.57 287.302M149.504 189.943L149.484 193.524L149.526 186.138M126.774 189.943L115.409 189.943C113.967 189.793 110.404 190.301 107.692 193.524L97.1588 205.945M126.774 189.943L126.754 193.524L126.796 186.138M97.1588 205.945L86.6254 218.367C85.416 219.561 82.6124 221.948 81.073 221.948L60.9891 221.948M97.1588 205.945L107.622 205.945L86.6959 205.945M40.9051 221.948L40.8785 226.648M40.9051 221.948L60.9891 221.948M40.9051 221.948L20.8212 221.948M60.9891 221.948L60.9624 226.648M20.8212 221.948L20.7945 226.648M212.016 307.893L223.698 307.893M212.016 307.893C210.775 304.858 209.356 301.396 207.798 297.597M207.798 297.597L223.757 297.597M207.798 297.597C206.481 294.387 205.064 290.937 203.57 287.302M203.57 287.302L223.815 287.302",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M339.829 317.069L339.788 324.231C339.702 325.276 340.155 327.365 342.657 327.365L412.65 327.365C413.291 327.365 415.062 326.111 417.015 321.098C417.444 319.997 419.456 315.175 422.518 307.893M634.773 221.948L614.689 221.948M497.734 189.943L497.714 193.524L497.756 186.138M497.734 189.943L486.369 189.943M497.734 189.943L509.099 189.943M486.369 189.943L475.005 189.943C472.888 189.943 471.383 192.33 470.895 193.524C460.411 218.249 443.332 258.563 431.198 287.302M486.369 189.943L486.349 193.524L486.391 186.138M509.099 189.943L520.464 189.943C521.908 189.793 525.465 190.301 528.14 193.524L538.533 205.945M509.099 189.943L509.079 193.524L509.121 186.138M538.533 205.945L548.925 218.367C550.121 219.561 552.898 221.948 554.437 221.948L574.521 221.948M538.533 205.945L528.07 205.945L548.996 205.945M594.605 221.948L594.578 226.648M594.605 221.948L574.521 221.948M594.605 221.948L614.689 221.948M574.521 221.948L574.494 226.648M614.689 221.948L614.662 226.648M422.518 307.893L410.836 307.893M422.518 307.893C423.794 304.858 425.252 301.396 426.854 297.597M426.854 297.597L410.895 297.597M426.854 297.597C428.207 294.387 429.663 290.937 431.198 287.302M431.198 287.302L410.953 287.302",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M318.345 202.028L319.352 24.7674C319.356 24.0213 319.845 22.5292 321.77 22.5292L524.052 22.5292C526.296 22.6039 530.79 21.9921 530.807 18.9482C530.824 15.9043 530.87 7.8321 530.891 4.17647C530.816 3.28121 531.243 1.49069 533.552 1.49069L625.503 1.1582",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M317.838 202.028L318.341 113.398L318.844 24.7674C318.848 24.0213 318.376 22.5292 316.455 22.5292L114.48 22.5292C112.238 22.6039 115.85 21.8119 115.867 18.7681C115.884 15.7242 115.93 7.65196 115.951 3.99632C116.036 3.10106 107.538 1.49069 105.233 1.49069L11.016 1.31055",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M317.594 337.884L317.549 345.941C317.377 347.881 318.093 351.76 322.326 351.76L497.189 351.76C498.47 351.909 501.955 351.044 505.637 346.389L563.292 274.32C564.341 273.052 566.873 270.516 568.605 270.516L634.269 270.516",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M316.593 337.884L316.547 345.941C316.696 347.881 315.937 351.76 311.703 351.76L136.841 351.76C135.557 351.909 132.082 351.044 128.453 346.389L71.6168 274.32C70.5817 273.052 68.0786 270.516 66.3468 270.516L0.683159 270.516",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 97.6548,
    y2: -1,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 537.761 22.7532)",
    stroke: "url(#paint12_linear_424_3509)",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 97.6548,
    y2: -1,
    transform: "matrix(1 1.14686e-09 -0.00567604 0.999984 2.34937 22.7532)",
    stroke: "url(#paint13_linear_424_3509)",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 620.014 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 605.089 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.15
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.03096e-10 -0.00567604 0.999984 590.165 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M575.236 193.822C575.239 193.41 575.575 193.076 575.987 193.076L584.313 193.076C585.418 193.076 586.308 193.971 586.302 195.076L586.299 195.707C586.293 196.726 585.462 197.552 584.443 197.552L578.946 197.552C576.885 197.552 575.225 195.882 575.236 193.822Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 16.3066 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 31.231 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.15
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 11.0727,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.03096e-10 -0.00567604 0.999984 46.1553 193.076)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0754 193.822C61.0777 193.41 60.7456 193.076 60.3335 193.076L52.0068 193.076C50.9023 193.076 50.0018 193.971 49.9955 195.076L49.9919 195.707C49.9861 196.726 50.8077 197.552 51.8269 197.552L57.3239 197.552C59.3841 197.552 61.0637 195.882 61.0754 193.822Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_424_3509",
    x1: 1.00005,
    y1: 17.1439,
    x2: 1.00005,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_424_3509",
    x1: 1.00006,
    y1: 35.3975,
    x2: 1.00006,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_424_3509",
    x1: 1.00005,
    y1: 30.0018,
    x2: 1.00005,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_424_3509",
    x1: 1.00006,
    y1: 61.3556,
    x2: 1.00006,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_424_3509",
    x1: 1.00005,
    y1: 17.1439,
    x2: 1.00005,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_424_3509",
    x1: 1.00006,
    y1: 35.3975,
    x2: 1.00006,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_424_3509",
    x1: 0.999756,
    y1: 222.5,
    x2: 21.9998,
    y2: 222.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_424_3509",
    x1: 0,
    y1: 0.5,
    x2: 21,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_424_3509",
    x1: 121.141,
    y1: 6.5,
    x2: 14.7384,
    y2: -10.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_424_3509",
    x1: 525.231,
    y1: 6.5,
    x2: 631.634,
    y2: -10.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_424_3509",
    x1: 1.00024,
    y1: 271.5,
    x2: 26.0002,
    y2: 271.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_424_3509",
    x1: 0,
    y1: 0.5,
    x2: 25,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_424_3509",
    x1: 0,
    y1: 0.5,
    x2: 97.6548,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_424_3509",
    x1: 0,
    y1: 0.5,
    x2: 97.6548,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Frame16);
export default __webpack_public_path__ + "static/media/card1-frame16.f37775c53aa07907acc45540cfbbdf2a.svg";
export { ForwardRef as ReactComponent };